var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSearchUserNameWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icSearchUserName") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.1824037,13.8034516 L12.7271267,10.4465985 C12.7087635,10.428758 12.6872232,10.4162882 12.6680339,10.3996823 C13.3479189,9.39771313 13.7447302,8.19832556 13.7447302,6.90850086 C13.7447302,3.39984927 10.8170948,0.555555556 7.20569845,0.555555556 C3.59430209,0.555555556 0.666666667,3.39984927 0.666666667,6.90843913 C0.666666667,10.4169673 3.59423855,13.2613227 7.20563491,13.2613227 C8.53331678,13.2613227 9.76778451,12.8758075 10.7991128,12.215277 C10.8162052,12.2338582 10.8289769,12.2547853 10.8473401,12.2726258 L14.3026807,15.6296023 C14.8217442,16.1338279 15.6632766,16.1338279 16.1824037,15.6296023 C16.7014037,15.1253151 16.7014037,14.3077388 16.1824037,13.8034516 Z M7.20569845,11.0589782 C4.84617997,11.0589782 2.93347934,9.20072689 2.93347934,6.90843913 C2.93347934,4.61608964 4.84624351,2.75783832 7.20569845,2.75783832 C9.56508984,2.75783832 11.477854,4.61615137 11.477854,6.90843913 C11.477854,9.20072689 9.56508984,11.0589782 7.20569845,11.0589782 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icSearchUserName",
    fill: "#d4d7dc",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchUserNameWhite);
export default __webpack_public_path__ + "static/media/icSearchUserNameWhite.cb694e1840579da3cfee79964fc89e17.svg";
export { ForwardRef as ReactComponent };